import React from "react";
import CodeMirror from "@uiw/react-codemirror";
import classes from "./Editor.module.css";

import { html } from "@codemirror/lang-html";
import { javascript } from "@codemirror/lang-javascript";
import { css } from "@codemirror/lang-css";
import { useState } from "react";
import { useContext } from "react";
import StoreContext from "../../Store/code-context";

export default function Editor(props) {
  const storeCtx = useContext(StoreContext);

  let lang;

  const [expendedBox, setExpendedBox] = useState(true);
  const { language, displayName, value, onChange } = props;

  if (language === "javascript") lang = javascript({ jsx: true });
  if (language === "html") lang = html({});
  if (language === "css") lang = css({});
  const handleChange = (value) => {
    onChange(value);
  };
  const buttonHandler = () => {
    setExpendedBox((prev) => !prev);
  };
  return (
    <div
      className={
        expendedBox
          ? classes["editor-container"]
          : classes["editor-container-collapesed"]
      }
    >
      <div className={classes.name}>
        <span>{displayName}</span>
        <button type="button" onClick={buttonHandler}>
          {expendedBox ? "↙" : "↗"}
        </button>
      </div>
      <CodeMirror
        className={classes.Editor}
        height={"50vh"}
        value={value}
        onChange={handleChange}
        extensions={[lang]}
        theme={storeCtx.Dark ? "dark" : "light"}
      />
    </div>
  );
}
